"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolTip = void 0;

var tslib_1 = require("tslib");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = (0, tslib_1.__importStar)(require("react"));

var constants_1 = require("./styled/constants");

var content_1 = require("./styled/content");

var root_1 = require("./styled/root");

var tip_1 = require("./styled/tip");

var trigger_1 = require("./styled/trigger");

var usePrevious = function usePrevious(value) {
  var ref = (0, react_1.useRef)();
  (0, react_1.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};

var ALIGNMENTS;

(function (ALIGNMENTS) {
  ALIGNMENTS["top"] = "top";
  ALIGNMENTS["right"] = "right";
  ALIGNMENTS["bottom"] = "bottom";
  ALIGNMENTS["left"] = "left";
})(ALIGNMENTS || (ALIGNMENTS = {}));

var STATE;

(function (STATE) {
  STATE["hidden"] = "hidden";
  STATE["preVisible"] = "preVisible";
  STATE["visible"] = "visible";
  STATE["repositionVisible"] = "repositionVisible";
  STATE["repositionHidden"] = "repositionHidden";
  STATE["preHidden"] = "preHidden";
})(STATE || (STATE = {}));

var ToolTip = function ToolTip(_a) {
  var __UIScope = _a.__UIScope,
      alignProp = _a.align,
      children = _a.children,
      className = _a.className,
      hidePointer = _a.hidePointer,
      hideTip = _a.hideTip,
      icon = _a.icon,
      id = _a.id,
      isInverse = _a.isInverse,
      tip = _a.tip;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'ToolTip',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _b = (0, react_1.useState)(STATE.hidden),
      tooltipState = _b[0],
      setTooltipState = _b[1];

  var prevTooltipState = usePrevious(tooltipState);
  var prevAlignProp = usePrevious(alignProp);

  var _c = (0, react_1.useState)(alignProp),
      align = _c[0],
      setAlign = _c[1]; // For setting the fixed position, necessary to overlap all elements


  var _d = (0, react_1.useState)(),
      offset = _d[0],
      setOffset = _d[1]; // If the tip needs to be slightly offset from the pointer, set that here


  var _e = (0, react_1.useState)(''),
      tipNudge = _e[0],
      setTipNudge = _e[1]; // Element wrapping the child


  var childWrapperElem = (0, react_1.useRef)(null); // Element wrapping entire component

  var containerElem = (0, react_1.useRef)(null); // Element wrapping tooltip

  var tipElem = (0, react_1.useRef)(null);
  var clickActive = (0, react_1.useRef)(false);
  var hoverActive = (0, react_1.useRef)(false);
  var mouseDownActive = (0, react_1.useRef)(false); // If the tip doesn't fit within its alignment based on the align prop, try to reposition it

  var reposition = (0, react_1.useCallback)(function () {
    var _a, _b, _c;

    if (!childWrapperElem.current || !tipElem.current) {
      return;
    }

    var _d = (_a = childWrapperElem.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(),
        top = _d.top,
        right = _d.right,
        bottom = _d.bottom,
        left = _d.left;

    var _e = tipElem.current,
        tipHeight = _e.offsetHeight,
        tipWidth = _e.offsetWidth;
    var roomOnTop = top - tipHeight >= constants_1.WINDOW_EDGE_MARGIN;
    var roomOnRight = right + tipWidth <= window.innerWidth - constants_1.WINDOW_EDGE_MARGIN && top >= constants_1.WINDOW_EDGE_MARGIN && bottom <= window.innerHeight - constants_1.WINDOW_EDGE_MARGIN;
    var roomOnBottom = bottom + tipHeight <= window.innerHeight - constants_1.WINDOW_EDGE_MARGIN;
    var roomOnLeft = left - tipWidth >= constants_1.WINDOW_EDGE_MARGIN && top >= constants_1.WINDOW_EDGE_MARGIN && bottom <= window.innerHeight - constants_1.WINDOW_EDGE_MARGIN;

    if (roomOnTop) {
      setAlign(ALIGNMENTS.top);
    } else if (roomOnLeft) {
      setAlign(ALIGNMENTS.left);
    } else if (roomOnRight) {
      setAlign(ALIGNMENTS.right);
    } else if (roomOnBottom) {
      setAlign(ALIGNMENTS.bottom);
    } // Get new rect in case we need to nudge the tip still


    var _f = (_b = tipElem.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect(),
        newLeft = _f.left,
        newRight = _f.right,
        newTop = _f.top,
        newBottom = _f.bottom; // Setup translation strings


    var translateX = '';
    var translateY = ''; // If we're still slightly overlapping on the left

    if (newLeft < constants_1.WINDOW_EDGE_MARGIN) {
      translateX = "translateX(" + (newLeft * -1 + constants_1.WINDOW_EDGE_MARGIN) / 16 + "rem)";
    } // Still overlapping on the right


    if (newRight > window.innerWidth - constants_1.WINDOW_EDGE_MARGIN) {
      translateX = "translateX(" + (window.innerWidth - newRight - constants_1.WINDOW_EDGE_MARGIN) / 16 + "rem)";
    } // Still overlapping on the top


    if (newTop < constants_1.WINDOW_EDGE_MARGIN) {
      translateY = "translateY(" + (newTop * -1 + constants_1.WINDOW_EDGE_MARGIN) / 16 + "rem)";
    } // Still overlapping on the bottom


    if (newBottom > window.innerHeight - constants_1.WINDOW_EDGE_MARGIN) {
      translateY = "translateY(" + (window.innerHeight - newBottom - constants_1.WINDOW_EDGE_MARGIN) / 16 + "rem)";
    }

    setTipNudge(translateX + " " + translateY);
    setOffset((_c = tipElem.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect());
  }, [setTipNudge, setOffset, setAlign]);
  var fixOrReposition = (0, react_1.useCallback)(function () {
    var _a, _b; // Reset values in case the screen size has changed


    setAlign(alignProp);
    setTipNudge('');

    var _c = (_a = tipElem.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(),
        top = _c.top,
        right = _c.right,
        bottom = _c.bottom,
        left = _c.left; // Are we overflowing the window anywhere?


    var overflowing = left < 0 || right > window.innerWidth || top < 0 || bottom > window.innerHeight;

    if (overflowing) {
      return reposition();
    } // If not overflowing, set the fixed position of the tooltip


    setOffset((_b = tipElem.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect());
  }, [alignProp, setAlign, setTipNudge, reposition]);
  var onFocus = (0, react_1.useCallback)(function () {
    if (hideTip) {
      return;
    }

    if (tooltipState !== STATE.preVisible && tooltipState !== STATE.visible) {
      setTooltipState(STATE.preVisible);
    }
  }, [setTooltipState, hideTip, tooltipState]);
  var onMouseEnter = (0, react_1.useCallback)(function () {
    if (hideTip) {
      return;
    } // Only take action if we aren't already in a hover state. Doing this check
    // helps avoid problems. For example, when the user clicks on the tooltip
    // trigger, that briefly changes the focus and triggers another hover event.
    // In that scenario, the state is already `visible` and we don't want to
    // change it to `preVisible` (which, in effect, causes a brief flicker).


    if (!hoverActive.current) {
      hoverActive.current = true;
      setTooltipState(STATE.preVisible);
    }
  }, [setTooltipState, hideTip]); // NB: 'onMouseLeave' is triggered when the user clicks the tooltip trigger
  // for Firefox and Chromium browsers, but not Safari.

  var onMouseLeave = (0, react_1.useCallback)(function () {
    if (!mouseDownActive.current) {
      hoverActive.current = false;
      setTooltipState(STATE.preHidden);
    }
  }, [setTooltipState]);
  var onBlur = (0, react_1.useCallback)(function () {
    if (!hoverActive.current) {
      setTooltipState(STATE.preHidden);
    }
  }, [setTooltipState]); // It's important to know if a click is in progress in some cases. For
  // example, a click triggers an 'onBlur' in some browsers. Normally we'd hide
  // the tooltip in that situation, but we don't want to after a click.

  var onMouseDown = (0, react_1.useCallback)(function () {
    mouseDownActive.current = true;
  }, []);
  var onMouseUp = (0, react_1.useCallback)(function () {
    mouseDownActive.current = false;
  }, []); // If the tooltip's content changes while it's visible, the dimensions of the
  // tooltip itself may have changed; it may need to be repositioned.

  (0, react_1.useEffect)(function () {
    if (hoverActive.current) {
      setTooltipState(STATE.repositionVisible);
    }
  }, [tip]); // If the alignment prop changes while the component is hidden, we need to
  // enter a new state that will allow the tooltip to be invisibly re-positioned
  // so that it will have the correct position if/when shown.

  (0, react_1.useEffect)(function () {
    if (alignProp !== prevAlignProp && tooltipState === STATE.hidden) {
      setTooltipState(STATE.repositionHidden);
    }
  }, [align, alignProp, tooltipState, setTooltipState, prevAlignProp]);
  (0, react_1.useEffect)(function () {
    if (tooltipState === prevTooltipState) {
      return;
    }

    switch (tooltipState) {
      case STATE.preVisible:
      case STATE.repositionVisible:
        fixOrReposition();
        setTooltipState(STATE.visible);
        clickActive.current = false;
        break;

      case STATE.preHidden:
        // Delay the change to 'hidden' briefly to give the browser time to
        // animate the tooltip's opacity change if a CSS transition has been
        // specified.
        setTimeout(function () {
          setTooltipState(STATE.hidden);
        }, 250);
        break;

      case STATE.repositionHidden:
        fixOrReposition();
        setTooltipState(STATE.hidden);
    }
  }, [prevTooltipState, tooltipState, fixOrReposition, setTooltipState]); // By default, the tooltip's <div> is 'absolute'-positioned relative to its
  // containing <div> (created by <Root>); in effect, relative to the element
  // whose hover will trigger the tooltip. A `transform()` is then applied to to
  // the tooltip's <div> to shift it above/below/left/right of the trigger.
  //
  // `position: absolute` is only temporary, however. This puts the tooltip in
  // the right X/Y location, but possibly the wrong Z index. It could be covered
  // up by some other element. To fix that, the the positioning is changed to
  // `fixed`, causing it to "float" above everythign else.
  //
  // The X/Y (i.e., top/left offset) coordinates of the tooltip <div> within the
  // window are captured _before_ the position is changed from `absolute` to
  // `fixed`, however. And that's critical, because those are then used to place
  // the fixed-positioned tooltip within the window.
  //
  // If the tooltip needs to be repositioned (e.g., the content has caused the
  // size of the tooltip to change), we need to briefly change it back to use
  // `position: absolute` so the browser can determine the proper x/y location
  // for us, capture those new coordinates, then use them while switching back
  // to `position: fixed`.
  //
  // Another important concern to be aware of is that the tooltip <div> can push
  // other DOM elements around while it has `position: absolute`. We therefore
  // use `max-width/height:0;` and `overflow:hidden` while the tooltip is hidden
  // to prevent it from "invisibly" affecting the layout of surrounding elements
  // (something that was a bug in the past; see AEP-924).

  var tipStyle = {};

  if (tooltipState === STATE.visible || tooltipState === STATE.preHidden) {
    tipStyle.top = offset === null || offset === void 0 ? void 0 : offset.top;
    tipStyle.left = offset === null || offset === void 0 ? void 0 : offset.left;
  }

  return react_1.default.createElement(root_1.Root, {
    ref: containerElem,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onFocus: onFocus,
    onBlur: onBlur,
    // `onMouseDownCapture` is being used here instead of `onMouseDown` to
    // ensure that our handler will get called, even if the underlying target
    // element has its own handler and disables the event from bubbling. For
    // more info see https://stackoverflow.com/a/42439628/62694.
    onMouseDownCapture: onMouseDown,
    onMouseUp: onMouseUp
  }, react_1.default.createElement(trigger_1.Trigger, {
    ref: childWrapperElem
  }, children), react_1.default.createElement(tip_1.Tip, {
    ref: tipElem,
    role: "tooltip",
    isInverse: isInverse,
    className: align + " " + tooltipState + " " + (hidePointer ? 'hide-pointer' : ''),
    style: tipStyle
  }, react_1.default.createElement(content_1.Content, {
    className: rootClasses,
    id: id,
    style: {
      transform: tipNudge
    },
    color: isInverse ? 'grey-dark' : 'grey-white',
    pattern: "captionMedium",
    px: 2,
    py: 1,
    isInverse: isInverse
  }, react_1.default.createElement(ui_flex_1.Flex, {
    alignItems: "center"
  }, icon && react_1.default.createElement(ui_icon_1.Icon, {
    name: icon,
    focusable: "false",
    "aria-hidden": "true",
    title: tip + " icon",
    color: isInverse ? 'grey-dark' : 'grey-white',
    mr: 1
  }), tip))));
};

exports.ToolTip = ToolTip;
ToolTip.defaultProps = {
  align: ALIGNMENTS.right,
  hideTip: false,
  hidePointer: false,
  tip: ''
};